module.exports = __webpack_public_path__ + "img/img_banner_index_04.0cf33b3c.jpg";